import React from 'react';
import { Box, Typography } from '@mui/material';

export default function Team() {
  return <Box><Typography variant="h4">Team</Typography></Box>;
}
